import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a wall-mounted split AC indoor unit authored at true
// mounting height (body centred at y = 2.2, back against the wall on -Z):
// a rounded white horizontal body with a thin vent slot strip.
const WARM_WHITE = "#efece6";
const SHELL = "#e2ded6";
const MATTE_BLACK = "#2e2e30";
const SCREEN = "#7f97a8";

export const airConditioner = defineModel({
  id: "air-conditioner",
  batchId: "modern",
  name: "Air Conditioner",
  tags: ["modern", "interior", "appliance", "utility", "climate", "wall-mounted"],
  summary: "A wall-mounted split AC indoor unit with a thin vent slot.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // main body (back flush against the wall at z = -0.1)
      { geometry: new THREE.BoxGeometry(0.8, 0.24, 0.2), color: WARM_WHITE, position: [0, 2.24, 0] },
      // rounded lower-front shell (cylinder lying along X)
      {
        geometry: new THREE.CylinderGeometry(0.09, 0.09, 0.78, 12),
        color: SHELL,
        position: [0, 2.12, 0.01],
        rotation: [0, 0, Math.PI / 2],
      },
      // thin vent slot strip along the lower front
      { geometry: new THREE.BoxGeometry(0.66, 0.03, 0.02), color: MATTE_BLACK, position: [0, 2.1, 0.095] },
      // small status display on the front right
      { geometry: new THREE.BoxGeometry(0.08, 0.05, 0.01), color: SCREEN, position: [0.28, 2.26, 0.101] },
    ];
  },
  animations: [],
});
